import { useContext } from "react"

import { BridgeContext } from "./BridgeContext"

export const useBridge = () => {
  const ctx = useContext(BridgeContext)
  if (!ctx) {
    throw new Error("useBridge must be used inside BridgeProvider")
  }
  return ctx
}
